import React from 'react';
import { ArrowRight, MessageCircle } from 'lucide-react';
import ctaMeshBg from '../images/generated-v2/cta-mesh-bg.png';
import { WHATSAPP_URL } from './constants';

export default function FinalCta({ onOpenDownload }) {
  return (
    <section className="relative overflow-hidden bg-ink-950">
      <img src={ctaMeshBg} className="absolute inset-0 w-full h-full object-cover opacity-85" alt="" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink-950/30 to-ink-950/60" />

      <div className="relative max-w-4xl mx-auto px-6 py-24 text-center">
        <h2 className="text-5xl md:text-6xl font-bold tracking-tighter text-white mb-6 text-balance">
          Tu próxima factura,<br />
          <span className="text-gradient-cyan">en 30 segundos.</span>
        </h2>
        <p className="text-xl text-white/65 leading-relaxed max-w-xl mx-auto mb-10">
          Empezá gratis. 11 tipos de DTE incluidos. Sin tarjeta de crédito. Sin contrato.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <button
            onClick={onOpenDownload}
            className="bg-white text-ink-950 text-[15px] font-semibold px-7 py-4 rounded-xl hover:bg-ink-100 transition inline-flex items-center gap-2 shadow-2xl shadow-cyan-500/30 cursor-pointer"
          >
            Descargar gratis
            <ArrowRight size={16} strokeWidth={2.5} />
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="glass text-white text-[15px] font-semibold px-7 py-4 rounded-xl hover:bg-white/15 transition inline-flex items-center gap-2"
          >
            <MessageCircle size={16} />
            Hablá con nosotros por WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
